module.exports={
	"Scope": "ObservationApprovalStep-List",
	"CoreEntity": "ObservationApprovalStep",
	"TitleTemplate": "Observation Approval Steps",
	"Descriptors":
	{
		"IDObservationApprovalState":
		{
			"Name": "State ID",
			"Hash": "ObsStepListStateID",
			"PictDashboard": {}
		},
		"Ordinal":
		{
			"Name": "Ordinal",
			"Hash": "ObsStepListOrdinal",
			"PictDashboard": {}
		},
		"ObservationType":
		{
			"Name": "Obs Type",
			"Hash": "ObsStepListObsType",
			"PictDashboard": {}
		},
		"IDRole":
		{
			"Name": "Role ID",
			"Hash": "ObsStepListIDRole",
			"PictDashboard": {}
		},
		"IncludeHigherRoles":
		{
			"Name": "Higher Roles",
			"Hash": "ObsStepListHigherRoles",
			"PictDashboard": {}
		},
		"PerformLock":
		{
			"Name": "Lock",
			"Hash": "ObsStepListLock",
			"PictDashboard": {}
		}
	}
}
